import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestsServices } from '../../../services/requests.service';

@Component({
  selector: 'app-redirect-establishment',
  providers: [RequestsServices],
  template: `
    <div class="main no-padding"><header-menu></header-menu></div>
    <div class="logo-gif"><img src="assets/shared/img/logo_allya.gif"></div>
  `,
})

export class RedirectEstablishmentComponent implements OnInit {

  constructor(
    private request: RequestsServices,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);
    if (this.route.snapshot.params.establishmentId) {
      const establishmentId = this.route.snapshot.params.establishmentId;

      this.getEstablishment(establishmentId);
    }
  }

  private getEstablishment(establishmentId) {
    this.request.get({ path: 'establishments', pathParam: `/${establishmentId}` }).then((establishment) => {
      this.router.navigate(['/parceiro/', establishment.slug]);
    });
  }
}
